module.exports = __webpack_public_path__ + "img/logo-m2n.26f8a6bb.svg";